<template>
  <v-container fluid>
    <v-btn color="primary" to="/settings/drivers/new">새 운전자 만들기</v-btn>
    <v-data-table
    :items="items"
    :loading="loading"
    :headers="headers"
    class="text-no-wrap">
      <template v-slot:item.edit="{ item }">
        <v-btn icon :to="getEditPath(item._id)"><v-icon>mdi-cog</v-icon></v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getDriverList } from '@/api'
// import get from 'lodash/get'
export default {
  data () {
    return {
      drivers: [],
      headers: [
        {
          text: '운전자명',
          value: 'name'
        },
        {
          text: '생년월일',
          value: 'birth'
        },
        {
          text: '입사일',
          value: 'enter'
        },
        {
          text: '편집',
          value: 'edit'
        }
      ],
      loading: false
    }
  },
  computed: {
    items () {
      return this.drivers.map(driver => {
        const birth = this.$moment(driver.birth).format('YYYY년 MM월 DD일')
        const enter = this.$moment(driver.enterDate).format('YYYY년 MM월 DD일')

        return {
          _id: driver._id,
          name: driver.name,
          birth,
          enter
        }
      })
    }
  },
  created () {
    this.fetchDrivers()
  },
  methods: {
    async fetchDrivers () {
      this.loading = true
      try {
        const query = {}
        const { drivers } = await getDriverList(null, query)

        this.drivers = drivers
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },
    getEditPath (_id) {
      return `/settings/drivers/edit/${_id}`
    }
  }
}
</script>
